import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-width": "150px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "渠道名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Logo"
    }
  }, [_c("upload-image", {
    attrs: {
      imageUrl: _vm.form.logo,
      fileSize: 512,
      maxWH: 720
    },
    model: {
      value: _vm.form.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logo", $$v);
      },
      expression: "form.logo"
    }
  }), _vm._v(" (512(k)为压缩限制)已上传文件 " + _vm._s(_vm.form.logo) + " ")], 1), _c("el-form-item", {
    attrs: {
      label: "登录模式"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.login_mode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "login_mode", $$v);
      },
      expression: "form.login_mode"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("强制登录")]), _c("el-radio", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("自动登录不提示")]), _c("el-radio", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("自动登录且10s倒数提示")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-tag", {
    attrs: {
      type: "warning"
    }
  }, [_vm._v("（以下开关不选默认全关闭）")])], 1), _c("el-form-item", {
    attrs: {
      label: "服务类型"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.service_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "service_type", $$v);
      },
      expression: "form.service_type"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("可服务")]), _c("el-radio", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("不可服务")]), _c("el-radio", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("重点服务")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "关注"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_focus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_focus", $$v);
      },
      expression: "form.is_focus"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "分享"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_share,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_share", $$v);
      },
      expression: "form.is_share"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "客服"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_super_kefu,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_super_kefu", $$v);
      },
      expression: "form.is_super_kefu"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏内vip"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_show_vip,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_vip", $$v);
      },
      expression: "form.is_show_vip"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏内Q群"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_show_qqun,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_qqun", $$v);
      },
      expression: "form.is_show_qqun"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "礼包"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_gift,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_gift", $$v);
      },
      expression: "form.is_gift"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "更多游戏"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.form.is_more_game,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_more_game", $$v);
      },
      expression: "form.is_more_game"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveApp
    }
  }, [_vm._v("保存")]), _c("el-button", [_vm._v("取消")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };